import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Column } from 'primereact/column'

import {
  Btn,
  CustomCheckbox,
  CustomDataTable,
  CustomDataTableHeader,
  CustomPanel,
  Loading,
  PageHeader,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  showMessageBox,
} from '../../../../store/actions/system.actions'
import * as TreinamentoHttp from '../../../../services/api/https/settings/treinamento.http'
import TreinamentoModal from './TreinamentoModal'

const INIT_TREINAMENTO = {
  id: null,
  title: '',
  description: '',
  transcription: '',
  link_video: '',
  tags: '',
  interno: false,
  tp_id: null,
  company_id: null,
  modulo: '',
  tela: '',
}

function Treinamentos({ dispatch, history }) {
  const [isLoading, setIsLoading] = useState(true)
  const [treinamentos, setTreinamentos] = useState([])
  const [showModal, setShowModal] = useState({ show: false, data: { ...INIT_TREINAMENTO } })
  const [globalFilter, setGlobalFilter] = useState('')

  async function fetchTreinamentos() {
    try {
      const response = await TreinamentoHttp.getTreinamentos()
      setTreinamentos(response)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchTreinamentos()
  }, [])

  const openNewModal = () => {
    setShowModal({ show: true, data: { ...INIT_TREINAMENTO } })
  }

  const openEditModal = treinamento => {
    if (!treinamento) return
    setShowModal({ show: true, data: { ...treinamento } })
  }

  const onModalClose = () => {
    setShowModal({ show: false, data: { ...INIT_TREINAMENTO } })
    fetchTreinamentos()
  }

  const internoBodyTemplate = rowData => {
    return <CustomCheckbox disabled checked={rowData.interno === 1 || rowData.interno === true} />
  }

  return (
    <React.Fragment>
      <PageHeader>S.33 - Cadastrar Vídeos de Treinamento</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div style={{ marginBottom: 10 }}>
            <Btn onClick={openNewModal}>Novo</Btn>
          </div>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <CustomDataTable
              value={treinamentos}
              selectionMode="single"
              onSelectionChange={e => openEditModal(e.value)}
              paginator
              rows={10}
              globalFilter={globalFilter}
              header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            >
              <Column field="id" header="Código" style={tableCellCentered(80)} />
              <Column field="title" header="Título" />
              <Column field="modulo" header="Módulo" />
              <Column
                field="interno"
                header="Interno"
                body={internoBodyTemplate}
                style={tableCellCentered(100)}
              />
            </CustomDataTable>
          )}
        </CustomPanel>
      </div>
      {showModal.show ? (
        <TreinamentoModal
          dispatch={dispatch}
          show={showModal.show}
          data={showModal.data}
          onClose={onModalClose}
        />
      ) : null}
    </React.Fragment>
  )
}

export default connect()(withRouter(Treinamentos))
